import NotificationType from "./NotificationType";

export default class Notification {
  public id: string;
  public name: string = '';
  public channelId: string = '';
  public timesRan: number;
  public lastRun: string | null;
  public createdOn: string;
  public updatedOn: string;
  public type: NotificationType | null = null;
};



// WEBPACK FOOTER //
// ./src/modules/consumer/models/Notification.ts